export default "__VITE_ASSET__B2WF5oq6__"